import { Injector } from '@angular/core';

export class CustomInjector {
    private static injector: Injector;

    public static setInjector(injector: Injector): void {
        // TODO: Throw error if injector is already set

        CustomInjector.injector = injector;
    }

    public static getInjector(): Injector {
        if (!CustomInjector.injector) {
            throw new Error('Injector not set; please initialize it first!');
        }

        return CustomInjector.injector;
    }
}
